import { useEffect, useRef, useState } from "react";

const BASE = process.env.REACT_APP_BACKEND_URL;

// Server-sent events with automatic polling fallback. onUpdate receives the parsed payload.
export function useLive(path, onUpdate, { enabled = true, fallbackMs = 4000, poll } = {}) {
  const [mode, setMode] = useState("connecting"); const cb = useRef(onUpdate); cb.current = onUpdate;
  useEffect(() => {
    if (!enabled || !path) return undefined;
    let es, timer, dead = false;
    const startPoll = () => { if (!poll || timer) return; setMode("polling"); timer = setInterval(() => poll().then((d) => d && cb.current(d)).catch(() => {}), fallbackMs); };
    try {
      es = new EventSource(`${BASE}/api${path}`, { withCredentials: true });
      es.addEventListener("hello", () => { if (!dead) { setMode("live"); if (timer) { clearInterval(timer); timer = null; } } });
      es.addEventListener("update", (e) => { try { cb.current(JSON.parse(e.data)); } catch { /* ignore */ } });
      es.onerror = () => { if (!dead) startPoll(); };
    } catch { startPoll(); }
    return () => { dead = true; es?.close(); if (timer) clearInterval(timer); };
  }, [path, enabled]); // eslint-disable-line
  return mode;
}
